import React from 'react';
import PaymentDialog from './paymentDialog/PaymentDialog';
import YardiPayDialog from 'components/tenant_app/components/YardiPayDialog';
import TenantPayDialog from 'components/tenant_app/components/TenantPayDialog';
import { STRIPE } from './PaymentConstants';

const TenantPaymentOptions = ({
  tenantOverview,
  yardiBased,
  paymentDetails,
  payDialogOpen,
  togglePayDialog,
  toggleAutopay,
  header,
  paymentHold = false,
  lockedAmount = false,
  hideClose = false,
  subHeader,
  showFeeInfo,
  hideAutoPayVerbiage,
}) => {
  if (tenantOverview.payment_provider === STRIPE && yardiBased) {
    return (
      <YardiPayDialog
        isOpen={payDialogOpen}
        toggleAutopay={toggleAutopay}
        toggleDialog={togglePayDialog}
        ledger={paymentDetails.yardiLedger}
      />
    );
  }

  if (tenantOverview.payment_provider === STRIPE) {
    return (
      <TenantPayDialog
        isOpen={payDialogOpen}
        toggleDialog={togglePayDialog}
        toggleAutopay={toggleAutopay}
        paymentDetails={paymentDetails}
      />
    );
  }

  return (
    <PaymentDialog
      header={header}
      subHeader={subHeader}
      isOpen={payDialogOpen}
      toggleDialog={togglePayDialog}
      toggleAutopay={toggleAutopay}
      paymentDetails={paymentDetails}
      tenantApplication={tenantOverview}
      yardiBased={yardiBased}
      paymentHold={paymentHold}
      lockedAmount={lockedAmount}
      hideClose={hideClose}
      showFeeInfo={showFeeInfo}
      hideAutoPayVerbiage={hideAutoPayVerbiage}
    />
  );
};

export default TenantPaymentOptions;
